module.exports = __webpack_public_path__ + "img/203.e2ec207f.jpg";